import type { AnalyticsProperties } from "./analytics";
import { loadAnalytics } from "./posthogAnalytics";

/**
 * Fire-and-forget report for an error the app caught.
 *
 * Separate from `trackEvent` because an error is not an event in the taxonomy: it has no place in
 * `APP_EVENTS`, belongs to no funnel, and PostHog groups it into an issue rather than a series.
 * Routing it through the event vocabulary would add an entry such as `boundary_crashed` to a list
 * in which every entry is a deliberate product measurement.
 */
export function reportCaughtError(error: unknown, properties?: AnalyticsProperties): void {
  void loadAnalytics()
    .then((analytics) => analytics.reportError(error, properties))
    .catch(() => {});
}
